import getApiSettingsHelper from 'Helper/getApiSettings';

/**
 * interface fot fetching a send message instance
 */
export interface DisconnectWebchatConfig {
    /**
     * userId
     */
    userId: string;
    /**
     * alias
     */
    alias: string;
    /**
     * secureKey
     */
    secureKey: string;
}

/**
 * sendMessage
 */
export const getApiSettings = (config: DisconnectWebchatConfig) => {
    const params = new URLSearchParams();
    params.append('userId', config.userId);
    params.append('alias', config.alias);
    params.append('secureKey', config.secureKey);

    return getApiSettingsHelper(params);
};
